import React, { useState, useEffect } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FiMap } from "react-icons/fi";
import { FaRegCreditCard } from "react-icons/fa";
import AddressForm from "../Checkout/AdressForm";
import PaymentForm from "../Checkout/PaymentForm";
import { commerce } from "../lib/commerce";
import { Link } from "react-router-dom";
import loadinggif from "../svg x gifs/Fast loading.gif";
import Lgif from "../svg x gifs/Progress indicator.gif";
import { useResultContext } from "../../../src/app";

import gif from "../../Components/svg x gifs/Drone Delivery.gif";
function Checkout({ cart, errorms, order, handleCaptureCHeckout }) {
  const [active, setactive] = useState(0);
  const [checkoutToken, setcheckoutToken] = useState(null);
  const [Shippingdata, setShippingdata] = useState({});
  const [loading, setloading] = useState(true);

  const { setactive: setactivea } = useResultContext();

  useEffect(() => {
    const generateToken = async () => {
      try {
        const token = await commerce.checkout.generateToken(cart.id, {
          type: "cart",
        });

        setloading(false);
        setcheckoutToken(token);
      } catch (errorms) {
        console.log(errorms);
      }
    };
    generateToken();
  }, [cart]);

  function Confirmation() {
    return (
      <>
        {order.customer ? (
          <div className="flex phonex2:px-4 justify-center text-center flex-col mt-[90px]">
            <div>
              <h1 className="text-xl">
                Thank you for your purchase,{" "}
                <span className="text-primary-100">
                  {order.customer.firstname} {order.customer.lastname}
                </span>
              </h1>
              <h2>order ref: {order.customer_reference} </h2>
            </div>
            <div className="flex justify-center items-center">
              <img src={gif} alt="" />
            </div>

            <h1 className="flex justify-center my-10">
              Redirected to{"  "}
              <Link onClick={() => setactivea(0)} to="/">
                <a className="border-b-2  ml-2 border-primary-100 text-primary-100">
                  {" "}
                  Home
                </a>
              </Link>
            </h1>
          </div>
        ) : (
          <div className="text-center flex justify-center my-10">
            <img className="" src={Lgif} alt="" />
          </div>
        )}
      </>
    );
  }

  if (errorms) {
    <>
      <div>
        <h1>Error: {errorms}</h1>
      </div>
      <br />
      <h1 className="flex justify-center">
        Redirected to{"  "}
        <Link to="/">
          <a className="border-b-2  ml-2 border-primary-100 text-primary-100">
            {" "}
            Home
          </a>
        </Link>
      </h1>
    </>;
  }

  function Form() {
    if (active === 0) {
      return <AddressForm checkoutToken={checkoutToken} next={next} />;
    } else if (active === 1) {
      return (
        <PaymentForm
          checkoutToken={checkoutToken}
          Shippingdata={Shippingdata}
          nextstep={nextstep}
          handleCaptureCHeckout={handleCaptureCHeckout}
        />
      );
    }
  }
  function nextstep() {
    setactive((prevactive) => prevactive + 1);
  }
  function backstep() {
    setactive((prevactive) => prevactive - 1);
  }
  function next(data) {
    setShippingdata(data);
    nextstep();
  }

  function Emptyproduct() {
    return (
      <div className="fixed z-[10000000] inset-0 bg-gray-900 bg-opacity-50  overflow-y-hidden flex justify-center items-center ">
        <div className="text-center">
          <svg
            role="status"
            className="inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-primary-100"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      </div>
    );
  }
  function Checkout() {
    return (
      <div className="mt-[150px]">
        <div className=" " />
        <div className=" w-full my-10  shadow-lg ">
          <div className="flex justify-center px-10  space-x-32 phonex2:space-x-8 phone:space-x-8 phone:text-center  ">
            <div className="flex flex-col   justify-center items-center  space-y-2 ">
              <div className="bg-primary-100  w-14 h-14 rounded-full shadow-lg flex justify-center items-center">
                <AiOutlineShoppingCart className="h-6 w-6 text-white " />
              </div>
              <hr />
              <h2 className="font-font1 text-[14px] md:text-base text-gray-700">
                Shopping Cart
              </h2>
            </div>
            <div className="relative flex flex-col justify-center items-center space-y-4">
              <div
                className={`${
                  active === 0
                    ? "border-2  border-primary-100 w-14 h-14 rounded-full shadow-lg flex justify-center items-center"
                    : "bg-primary-100 w-14 h-14 rounded-full shadow-lg flex justify-center items-center"
                }`}
              >
                <FiMap
                  className={`${
                    active === 0
                      ? "h-6 w-6 text-gray-500 "
                      : "h-6 w-6 text-white "
                  }`}
                />
              </div>
              <h2
                className={`${
                  active === 0
                    ? "font-font1 text-[14px] md:text-base relative text-gray-500"
                    : "font-font1 text-[14px] md:text-base relative text-gray-700"
                }`}
              >
                Delivery Adress{" "}
              </h2>
              {active === 0 && (
                <div className="absolute ">
                  <span className="flex h-3 w-3 relative mdd:mb-[26px] ">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-primary-100"></span>
                  </span>
                </div>
              )}
            </div>
            <div className="relative flex flex-col justify-center items-center space-y-4 ">
              <div
                className={`${
                  active === 2 &&
                  " bg-primary-100 w-14 h-14 rounded-full shadow-lg flex justify-center items-center"
                }  border-2 border-primary-100 w-14 h-14 rounded-full shadow-lg flex justify-center items-center`}
              >
                <FaRegCreditCard
                  className={`${
                    active === 2
                      ? "h-6 w-6 text-white "
                      : "h-6 w-6 text-gray-500"
                  }`}
                />
              </div>
              <h2
                className={`${
                  active === 2
                    ? "font-font1 text-[14px] md:text-base text-gray-800"
                    : "font-font1 text-[14px] md:text-base text-gray-500"
                } `}
              >
                Payment Method
              </h2>
              {active === 1 && (
                <div className="absolute ">
                  <span className="flex h-3 w-3 relative   mdd:mb-[26px]">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-primary-100"></span>
                  </span>
                </div>
              )}
            </div>
          </div>
          {active === 2 ? <Confirmation /> : checkoutToken && <Form />}
        </div>{" "}
        {active === 0 && (
          <Link to="/cart">
            <div className="bg-red-500 w-fit rounded-md my-10 mb-[100px]">
              <button className="px-10 py-6 rounded-md text-white">
                Back To Cart
              </button>
            </div>
          </Link>
        )}
        {active === 1 && (
          <div
            onClick={backstep}
            className="bg-red-500 w-fit rounded-md my-10 mb-[100px]"
          >
            <button className="px-10 py-6 rounded-md text-white">
              Back To Cart
            </button>
          </div>
        )}
      </div>
    );
  }
  return <> {loading ? <Emptyproduct /> : <Checkout />}</>;
}

export default Checkout;
